import React from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import CardSection from "./CardSection";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/reservas",
    label: "Reservas por Tipo",
  },
  {
    path: "/reservas/guarderia",
    label: "Reserva Guarderia",
    isActive: true,
  },
];

function ReservasGuarderia() {
  return (
    <Page
      title="Reservas de Guardería"
      description="Acciones en reservas de Guardería."
      breadCrumbs={breadCrumbs}
    >
      <CardSection />
    </Page>
  );
}

export default ReservasGuarderia;
